/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Unit enum
 * @export
 */
export const UnitEnum = {
    Day: 1,
    Week: 2,
    Month: 3,
    Year: 4,
    Amount: 5
} as const;
export type UnitEnum = typeof UnitEnum[keyof typeof UnitEnum];


export function instanceOfUnitEnum(value: any): boolean {
    for (const key in UnitEnum) {
        if (Object.prototype.hasOwnProperty.call(UnitEnum, key)) {
            if (UnitEnum[key as keyof typeof UnitEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UnitEnumFromJSON(json: any): UnitEnum {
    return UnitEnumFromJSONTyped(json, false);
}

export function UnitEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnitEnum {
    return json as UnitEnum;
}

export function UnitEnumToJSON(value?: UnitEnum | null): any {
    return value as any;
}

export function UnitEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): UnitEnum {
    return value as UnitEnum;
}

